export const homepage = '/';
